import { useEffect, useRef } from "react"
import React, { useLayoutEffect, useState } from 'react';

let myInterval

const defaultItemPerpage = {
  xs: 5,
  sm: 5,
  md: 5,
  lg: 5
}

const DraggableMarquee = ({ itemsPerPage = defaultItemPerpage, speed = 100, children, controller }) => {
  const [width] = useWindowSize();

  const _itemsPerPage =
    width >= 1024 ? itemsPerPage.lg
      : width >= 768 ? itemsPerPage.md
        : width >= 640 ? itemsPerPage.sm
          : itemsPerPage.xs

  const _items = children.length >= _itemsPerPage + 2
    ? children
    : new Array(_itemsPerPage + 2).fill(null).map((item, i) => {
      return children[i % children.length]
    })


  useEffect(() => {
    isMoving.current = true;

    const items = document.getElementsByClassName('item')
    for (let i = 0; i < items.length; i++) {
      items[i].style.transform = `translateX(${(100 / _itemsPerPage) * i}vw)`
    }

    isMoving.current = false;
  }, [width, _itemsPerPage])

  // console.log('_items', _items)
  const _speedDirection = useRef(-(speed / 100));
  const isMoving = useRef(false)
  const isHover = useRef(false)
  const startClickPos = useRef()

  const allElementsStartPos = useRef([])

  const onMouseDown = () => {
    const _allElementsStartPos = []
    const items = document.getElementsByClassName('item')

    for (let i = 0; i < items.length; i++) {

      const style = window.getComputedStyle(items[i]);
      const matrix = new WebKitCSSMatrix(style.transform);

      const translateX = matrix.m41;
      _allElementsStartPos.push(translateX)
    }

    allElementsStartPos.current = _allElementsStartPos
  }

  useEffect(() => {
    if (myInterval) {
      clearInterval(myInterval)
    }

    myInterval = setInterval(() => {
      if (isMoving.current || isHover.current) return;

      onMouseDown()

      const _mouseDiff = _speedDirection.current;

      const items = document.getElementsByClassName('item')

      for (let i = 0; i < items.length; i++) {

        let _init = allElementsStartPos.current[i];

        const _boxSize = screen.width / _itemsPerPage;

        items[i].style.transition = 'none';

        if (_init + _mouseDiff < (_boxSize * (-2))) { // Too far on left
          _init += (_boxSize * (_items.length));
        } else if (_init + _mouseDiff > (_boxSize * (_items.length - 1))) {
          _init -= (_boxSize * (_items.length));
        }

        items[i].style.transform = `translateX(${_init + _mouseDiff}px)`
      }
    }, 10)
    return () => clearInterval(myInterval)
  }, [width, _items])

  useEffect(() => {
    const moveLeft = () => {
      _speedDirection.current = -20
      setTimeout(() => {
        _speedDirection.current = -(speed / 100)
      }, 100)
    }

    const moveRight = () => {
      _speedDirection.current = 20
      setTimeout(() => {
        _speedDirection.current = -(speed / 100)
      }, 100)
    }

    controller.current.moveLeft = moveLeft;
    controller.current.moveRight = moveRight;
  }, [])

  useEffect(() => {
    const onMouseMove = (e) => {
      if (!isMoving.current) return;

      let _xNow

      if (e.type == 'touchmove') {
        var evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
        var touch = evt.touches[0] || evt.changedTouches[0];
        _xNow = touch.pageX;
      } else {
        _xNow = e.clientX;
      }

      const _mouseDiff = _xNow - startClickPos.current;

      const items = document.getElementsByClassName('item')

      for (let i = 0; i < items.length; i++) {

        let _init = allElementsStartPos.current[i];

        const _boxSize = screen.width / _itemsPerPage;

        items[i].style.transition = 'none';

        if (_init + _mouseDiff < (_boxSize * (-2))) { // Too far on left
          console.log("TOO FAR LEFT")
          _init += (_boxSize * (_items.length));
        } else if (_init + _mouseDiff > (_boxSize * (_items.length - 1))) {
          _init -= (_boxSize * (_items.length));
        }

        items[i].style.transform = `translateX(${_init + _mouseDiff}px)`
      }

    }

    const onMouseUp = (e) => {
      if (!isMoving.current) return;

      // const _xNow = e.clientX;

      isMoving.current = false;
      allElementsStartPos.current = [];
    }

    document.addEventListener('mousemove', onMouseMove)
    document.addEventListener('mouseup', onMouseUp)

    document.addEventListener('touchmove', onMouseMove)
    document.addEventListener('touchend', onMouseUp)

    return () => {
      document.removeEventListener('mousemove', onMouseMove)
      document.removeEventListener('mouseup', onMouseUp)

      document.removeEventListener('touchmove', onMouseMove)
      document.removeEventListener('touchend', onMouseUp)
    }
  }, [width, _items])

  if (width === 0) {
    return (<div />)
  }

  return (
    <>
      <div
        className="w-full overflow-hidden"
        onMouseDown={(e) => {
          onMouseDown();
          startClickPos.current = e.clientX;
          isMoving.current = true;
        }}
        onTouchStart={(e) => {
          onMouseDown();
          var evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
          var touch = evt.touches[0] || evt.changedTouches[0];
          startClickPos.current = touch.pageX;
          isMoving.current = true;
        }}
        onMouseEnter={() => {
          isHover.current = true;
        }}
        onMouseLeave={() => {
          isHover.current = false;
        }}
      >
        <div className="relative" style={{ minWidth: `${_items.length * (100 / _itemsPerPage)}vw` }}>
          {
            _items.map((item, i) => {
              return (
                <div key={i} className="absolute item" style={{ width: `${100 / _itemsPerPage}vw`, transform: `translateX(${(100 / _itemsPerPage) * i}vw)` }}>
                  {item}
                </div>
              )
            })
          }
          <div className="flex opacity-0 pointer-events-none">
            {children.map((item, i) => {
              return (
                <div style={{ width: `${100 / _itemsPerPage}vw` }} key={i}>
                  {item}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}


function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}

const Compose = (props) => {
  if (!props.children || !props.children.length) return (<div />)

  return (
    <DraggableMarquee {...props} />
  )
}

export default Compose